import type { Attachment as GQLAttachment } from '@/generated/graphql';
import { AttachmentStatusEnum as GQLAttachmentStatusEnum } from '@/generated/graphql';
import { take } from '@/helpers/takePayload';

export type Attachment = {
  id?: number;
  // account_id: number;
  name: string;
  mime: string;
  size: number;
  checksum?: string;
  status?: AttachmentStatus;
  url?: string;
};

export enum AttachmentStatus {
  PENDING = 'pending',
  UPLOADING = 'uploading',
  READY = 'ready',
  FAILED = 'failed',
}

export const gqlStatusMap = {
  [GQLAttachmentStatusEnum.Pending]: AttachmentStatus.PENDING,
  [GQLAttachmentStatusEnum.Uploading]: AttachmentStatus.UPLOADING,
  [GQLAttachmentStatusEnum.Ready]: AttachmentStatus.READY,
};

export const fromGql = (gqlItem: GQLAttachment): Attachment => ({
  ...(take<Attachment>(gqlItem, 'id', 'name', 'mime', 'size', 'checksum', 'url') as Attachment),
  status: gqlItem.status ? gqlStatusMap[gqlItem.status] : undefined,
});
